import React, { useState } from 'react';
import './Inventarios.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ArticulosData from '../../Components/Admin/ArticulosData/ArticulosData';
import UnidadesData from '../../Components/Admin/UnidadesData/UnidadesData';
import CategoriasInventarioData from '../../Components/Admin/CategoriasInventarioData/CategoriasInventarioData';
import ProveedoresData from '../../Components/Admin/ProveedoresData/ProveedoresData';
import RecetasData from '../../Components/Admin/RecetasData/RecetasData';
import MovimientosData from '../../Components/Admin/MovimientosData/MovimientosData';

export default function Inventarios() {
    const [tabActiva, setTabActiva] = useState('articulos');

    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection inventariosContainer'>
                <HeaderDash />
                <div className='inventarios-container-wrapper'>
                    <div className='inventariosTabs'>
                        <button
                            className={tabActiva === 'articulos' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('articulos')}
                        >
                            Artículos
                        </button>
                        <button
                            className={tabActiva === 'unidades' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('unidades')}
                        >
                            Unidades de Medida
                        </button>
                        <button
                            className={tabActiva === 'categorias' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('categorias')}
                        >
                            Categorías
                        </button>
                        <button
                            className={tabActiva === 'proveedores' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('proveedores')}
                        >
                            Proveedores
                        </button>
                        <button
                            className={tabActiva === 'recetas' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('recetas')}
                        >
                            Recetas
                        </button>
                        <button
                            className={tabActiva === 'movimientos' ? 'tabActiva' : ''}
                            onClick={() => setTabActiva('movimientos')}
                        >
                            Movimientos
                        </button>
                    </div>

                    <div className='inventariosContent'>
                        {tabActiva === 'articulos' && <ArticulosData />}
                        {tabActiva === 'unidades' && <UnidadesData />}
                        {tabActiva === 'categorias' && <CategoriasInventarioData />}
                        {tabActiva === 'proveedores' && <ProveedoresData />}
                        {tabActiva === 'recetas' && <RecetasData />}
                        {tabActiva === 'movimientos' && <MovimientosData />}
                    </div>
                </div>
            </section>
        </div>
    );
}


